// Nepal Coverage Map — geographic & cultural breadth dashboard
// Mirrors docs/knowledge/coverage-map.yaml (manual sync until API exists)

export const COVERAGE_MAP_META = {
	lastAudit: '2026-07-13',
	editorialStrategy: 'Nepal-first',
	depthBenchmark: 'Everest Base Camp Guided Journey',
	longTermGoal: 'No meaningful destination in Nepal missing from VisitAllNepal',
};

export const COVERAGE_CATEGORIES = [
	{ id: 'provinces', name: 'Provinces', covered: 7, total: 7, coverage: 100, status: 'partial', route: '/provinces' },
	{ id: 'districts', name: 'Districts', covered: 11, total: 77, coverage: 14, status: 'critical_gap', route: '/provinces' },
	{ id: 'municipalities', name: 'Municipalities', covered: 8, total: 753, coverage: 1, status: 'critical_gap', route: '/provinces' },
	{ id: 'unesco_sites', name: 'UNESCO Sites', covered: 3, total: 10, coverage: 30, status: 'partial', route: '/destinations' },
	{ id: 'national_parks', name: 'National Parks', covered: 2, total: 12, coverage: 17, status: 'critical_gap', route: '/destinations' },
	{ id: 'conservation_areas', name: 'Conservation Areas', covered: 0, total: 6, coverage: 0, status: 'critical_gap', route: '/destinations' },
	{ id: 'wildlife_reserves', name: 'Wildlife Reserves', covered: 0, total: 4, coverage: 0, status: 'critical_gap', route: '/destinations' },
	{ id: 'trekking_regions', name: 'Trekking Regions', covered: 5, total: 24, coverage: 21, status: 'partial', route: '/journeys' },
	{ id: 'mountain_passes', name: 'Mountain Passes', covered: 2, total: 40, coverage: 5, status: 'critical_gap', route: '/destinations' },
	{ id: 'lakes', name: 'Lakes', covered: 2, total: 30, coverage: 7, status: 'critical_gap', route: '/destinations' },
	{ id: 'waterfalls', name: 'Waterfalls', covered: 1, total: 25, coverage: 4, status: 'critical_gap', route: '/destinations' },
	{ id: 'rivers', name: 'Rivers', covered: 3, total: 20, coverage: 15, status: 'partial', route: '/destinations' },
	{ id: 'caves', name: 'Caves', covered: 1, total: 15, coverage: 7, status: 'critical_gap', route: '/destinations' },
	{ id: 'monasteries', name: 'Monasteries', covered: 3, total: 50, coverage: 6, status: 'critical_gap', route: '/destinations' },
	{ id: 'temples', name: 'Temples', covered: 4, total: 40, coverage: 10, status: 'partial', route: '/destinations' },
	{ id: 'villages', name: 'Villages', covered: 6, total: 200, coverage: 3, status: 'critical_gap', route: '/destinations' },
	{ id: 'hidden_gems', name: 'Hidden Gems', covered: 3, total: 50, coverage: 6, status: 'critical_gap', route: '/destinations' },
	{ id: 'festivals', name: 'Festivals', covered: 16, total: 50, coverage: 32, status: 'partial', route: '/festivals' },
	{ id: 'local_foods', name: 'Local Foods', covered: 8, total: 40, coverage: 20, status: 'partial', route: '/plan/food' },
	{ id: 'markets', name: 'Markets', covered: 2, total: 30, coverage: 7, status: 'critical_gap', route: '/shopping' },
	{ id: 'museums', name: 'Museums', covered: 1, total: 25, coverage: 4, status: 'critical_gap', route: '/destinations' },
	{ id: 'adventure_activities', name: 'Adventure Activities', covered: 6, total: 20, coverage: 30, status: 'partial', route: '/plan/adventure' },
	{ id: 'border_towns', name: 'Border Towns', covered: 0, total: 12, coverage: 0, status: 'critical_gap', route: '/transportation' },
];

export const PRIORITY_BREADTH_TARGETS = [
	{ slug: 'dolpo', name: 'Dolpo (Upper & Lower)', district: 'Dolpa', province: 'Karnali', coverage: 0, status: 'not_started' },
	{ slug: 'rara', name: 'Rara Lake', district: 'Mugu', province: 'Karnali', coverage: 5, status: 'stub' },
	{ slug: 'khaptad', name: 'Khaptad National Park', district: 'Bajhang', province: 'Sudurpashchim', coverage: 0, status: 'not_started' },
	{ slug: 'api-nampa', name: 'Api Nampa Conservation Area', district: 'Darchula', province: 'Sudurpashchim', coverage: 0, status: 'not_started' },
	{ slug: 'dhorpatan', name: 'Dhorpatan Hunting Reserve', district: 'Baglung', province: 'Gandaki', coverage: 0, status: 'not_started' },
	{ slug: 'tsum-valley', name: 'Tsum Valley', district: 'Gorkha', province: 'Gandaki', coverage: 10, status: 'stub' },
	{ slug: 'nar-phu', name: 'Nar Phu', district: 'Manang', province: 'Gandaki', coverage: 10, status: 'stub' },
	{ slug: 'kanchenjunga', name: 'Kanchenjunga Region', district: 'Taplejung', province: 'Koshi', coverage: 5, status: 'stub' },
	{ slug: 'makalu', name: 'Makalu-Barun', district: 'Sankhuwasabha', province: 'Koshi', coverage: 0, status: 'not_started' },
	{ slug: 'ilam', name: 'Ilam (beyond tea)', district: 'Ilam', province: 'Koshi', coverage: 15, status: 'partial' },
	{ slug: 'bandipur', name: 'Bandipur', district: 'Tanahun', province: 'Gandaki', coverage: 0, status: 'not_started' },
	{ slug: 'gorkha', name: 'Gorkha', district: 'Gorkha', province: 'Gandaki', coverage: 0, status: 'not_started' },
	{ slug: 'janakpur', name: 'Janakpur', district: 'Dhanusha', province: 'Madhesh', coverage: 0, status: 'not_started' },
	{ slug: 'lumbini-depth', name: 'Lumbini (full depth)', district: 'Rupandehi', province: 'Lumbini', coverage: 25, status: 'partial' },
	{ slug: 'humla', name: 'Humla & Limi Valley', district: 'Humla', province: 'Karnali', coverage: 0, status: 'not_started' },
	{ slug: 'mustang-villages', name: 'Mustang villages beyond Jomsom', district: 'Mustang', province: 'Gandaki', coverage: 20, status: 'partial' },
];

export const SOURCE_TIERS = [
	{
		tier: 1,
		name: 'Official',
		description: 'Regulations, fees, boundaries — Immigration, NTB, DNPWC, UNESCO, CAAN',
	},
	{
		tier: 2,
		name: 'Expert',
		description: 'TAAN, NMA, park offices, museums, academic sources',
	},
	{
		tier: 3,
		name: 'Local Experience',
		description: 'Viewpoints, cafés, photography, seasonal feel — never for permit facts',
	},
];

export function coverageBarBlocks(coverage) {
	const filled = Math.round(coverage / 10);
	return { filled: Math.min(filled, 10), empty: Math.max(10 - filled, 0) };
}

export function statusLabel(status) {
	const map = {
		complete: 'Complete',
		partial: 'Partial',
		critical_gap: 'Critical gap',
		not_started: 'Not started',
		stub: 'Stub',
	};
	return map[status] || status;
}
